import useContextWithErrorHandler from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { ReportsContext } from '../providers/ReportsProvider';
import { UseReports } from '../providers/ReportsProvider/types';

const useReports = (): UseReports => {
  const [state, dispatch] = useContextWithErrorHandler(ReportsContext, 'ReportsProvider');
  return [state, dispatch];
};

export default useReports;
